const BASE = '/api/conversations';

const req = (method: string, path: string, body?: unknown) =>
  fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  }).then(async (res) => {
    if (!res.ok) {
      const text = await res.text().catch(() => res.statusText);
      throw new Error(text || `HTTP ${res.status}`);
    }
    if (res.status === 204) return undefined;
    return res.json();
  });

export interface Conversation {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
  message_count: number;
}

export interface ConversationListResult {
  total: number;
  items: Conversation[];
}

/** 助理訊息的「分析過程」（後端 messages.analysis）；舊訊息、API 路徑為 null */
export interface MessageAnalysis {
  log: string;
  subs: [string, string][];
}

export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  created_at: string;
  analysis?: MessageAnalysis | null;
}

export interface ConversationDetail {
  id: string;
  title: string;
  messages: Message[];
}

export const conversationsApi = {
  list: (limit = 40, offset = 0): Promise<ConversationListResult> =>
    req('GET', `?limit=${limit}&offset=${offset}`),

  getMessages: (id: string): Promise<ConversationDetail> =>
    req('GET', `/${id}/messages`),

  rename: (id: string, title: string): Promise<{ id: string; title: string }> =>
    req('PATCH', `/${id}`, { title }),

  delete: (id: string): Promise<void> =>
    req('DELETE', `/${id}`),
};
